import Store from 'lightningjs-redux';
import { getCurrentLayout } from '../../logic/layout/layout.selectors';

import {
  getCanPlay,
  getPlaybackState,
  getSideGlassContent,
  getAudioTracks,
  getSubtitleTracks,
  isAdMode,
  shouldSwitchToNextProgram,
  getStartTimeInSeconds,
  shouldLoadNewMetadataItems,
  isLiveStartOverEnabled,
  isPlayerLoading,
} from '../../logic/player/player.selectors';
import { getCurrentVideoItem, isVideoEnding } from '../../logic/player/video.selectors';
import { isOnLive } from '../../logic/player/live.selectors';

const mapControllers = instance => ({
  shouldSwitchToNextProgram: {
    selector: shouldSwitchToNextProgram,
    callback: value => {
      instance.shouldSwitchToNextProgram = value;
    },
  },
  shouldLoadNewMetadataItems: {
    selector: shouldLoadNewMetadataItems,
    callback: value => {
      instance.shouldLoadNewMetadataItems = value;
    },
  },
  layout: {
    selector: getCurrentLayout,
    shouldBeInvokedOnConnect: true,
    callback: () => {
      instance.start();
    },
  },
  canPlay: {
    selector: getCanPlay,
    callback: value => {
      instance.canPlay = value;
    },
  },
  playbackState: {
    selector: getPlaybackState,
    callback: value => {
      instance.playbackState = value;
    },
  },
  isLoading: {
    selector: isPlayerLoading,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.isLoading = value;
    },
  },
  isAdBreakDisplayed: {
    selector: isAdMode,
    callback: value => {
      instance.isAdBreakDisplayed = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  sideGlass: {
    selector: getSideGlassContent,
    callback: value => {
      instance.hasRelatedVideos = value;
    },
  },
  audioTracks: {
    selector: getAudioTracks,
    callback: value => {
      instance.audioTracks = value;
    },
  },
  subtitleTracks: {
    selector: getSubtitleTracks,
    callback: value => {
      instance.subtitleTracks = value;
    },
  },
  programInformation: {
    selector: getCurrentVideoItem,
    callback: value => {
      instance.programInformation = value;
    },
  },
  isVideoEnding: {
    selector: isVideoEnding,
    callback: value => {
      instance.isVideoEnding = value;
    },
  },
  startTimeInSeconds: {
    selector: getStartTimeInSeconds,
    callback: value => {
      instance.startTimeInSeconds = value;
    },
  },
  startOverFeature: {
    selector: isLiveStartOverEnabled,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.startOverFeature = value;
    },
  },
  isOnLive: {
    selector: isOnLive,
    callback: value => {
      instance.isOnLive = value;
    },
  },
});

export default Store.control(mapControllers);
